"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_uid_1 = require("react-uid");
const videoStyles_1 = require("../../styling/videoStyles");
const styles_1 = tslib_1.__importDefault(require("./styles"));
const Checkbox = ({ classes = {}, label, checked, id, title, disabled, ...rest }) => {
    var _a;
    const [state, setState] = (0, react_1.useState)(checked);
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes, target: styles_1.default }, "checkbox");
    const handleChange = () => {
        if (rest.onChange !== undefined) {
            rest.onChange();
        }
        setState(checked);
    };
    const uid = (0, react_uid_1.useUID)();
    return (react_1.default.createElement("div", { className: `${mergedClasses.root} ${mergedClasses.fields} ${mergedClasses.checkbox}` },
        react_1.default.createElement("label", { htmlFor: uid, className: disabled ? `${mergedClasses.label} ${mergedClasses.labelDisabled}` : mergedClasses.label, title: title },
            react_1.default.createElement("input", { type: "checkbox", className: `${mergedClasses.input}`, id: uid, "data-selenium": (_a = rest === null || rest === void 0 ? void 0 : rest.tag) !== null && _a !== void 0 ? _a : "checkbox-input", onChange: handleChange, checked: state, title: title, disabled: disabled, ...rest }),
            label)));
};
exports.default = Checkbox;
//# sourceMappingURL=Checkbox.js.map